import React from "react";
import PageLayout from "../../components/layouts/PageLayout";
import CustomNavbar from "../../components/common/CustomNavbar";
import { useNavigate } from "react-router-dom";
import BroadcastList from "./BroadcastList";

const BroadCasts = () => {
  const navigate = useNavigate();

  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <span className="font-bold text-lg uppercase">Broadcasts</span>
        </CustomNavbar>
      }
    >
      <div className="flex flex-col items-end justify-end sm:flex-row gap-4 sm:items-center">
        <button
          onClick={() => navigate("/admin/variables-send-message/broadcast")}
          className=" flex items-center justify-center px-5 py-3 rounded-4xl bg-brand-blue-gradient text-white font-bold whitespace-nowrap"
        >
          New Broadcasts
        </button>
      </div>

      <BroadcastList />
    </PageLayout>
  );
};

export default BroadCasts;